import PricingCard from "@/components/Cards/PricingCard.";
import { useSubscripton } from "@/hooks/subscriptionService";
import { useDashboardTheme } from "../MeetingDashboard/themeHelper";

type PricingItem = {
  plan?: string;
  displayName?: string;
  name?: string;
  price: number;
  licenses?: number[];
  tokenlimit?: number;
  features?: string[];
  description?: string;
};

const Subscription = () => {
  const { isDark } = useDashboardTheme();
  const { data, isLoading, isError } = useSubscripton();
  const pricingData: PricingItem[] = data?.data?.items || [];

  // ✅ Reorder: Free plan first
  const reorderedData = [
    ...pricingData.filter((item) => item?.name === "FREE"),
    ...pricingData.filter((item) => item?.name !== "FREE"),
  ];

  return (
    <>
      <main className={"flex-1 p-2 mt-22 " + (isDark ? "" : "light-theme-dashboard")} style={{ background: isDark ? "" : "#F4F5F7" }}>
        <div className="min-h-[75vh] bg-[#0F0E15] rounded-xl p-6 mx-auto shadow-lg credit-usage-container">
          <div className="w-full h-full grid gap-4 grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 items-stretch justify-center">
            {isLoading && <p className="text-gray-400 text-sm">Loading...</p>}
            {isError && (
              <p className="text-red-400 text-sm">Failed to load requests.</p>
            )}
            {!isLoading && !isError && pricingData.length === 0 && (
              <p className="text-gray-400 text-sm">No Subscription found.</p>
            )}

            {!isLoading &&
              reorderedData.length > 0 &&
              reorderedData
                .filter((item) => item?.name)
                .map((item, i) => {
                  const featureEntries = item.features || {};
                  const featureNames = Object.keys(featureEntries);
                  const featureState = featureEntries;

                  const transformedItem = {
                    plan: item.displayName || item.name,
                    price: `$${item.price}`,
                    licenses: item.licenses || [],
                    credits: [item.tokenlimit as number],
                    features: featureNames,
                    featureState,
                    popular: item.name === "FREE",
                    mostPopular: item.name === "PRO",
                    current: item.name === "FREE",
                    description: item.description || "",
                  };

                  return (
                    <PricingCard
                      aiInsights={false}
                      key={i}
                      {...transformedItem}
                    />
                  );
                })}
          </div>
        </div>
      </main>
    </>
  );
};

export default Subscription;
